import styled from 'styled-components';
import {
  Link,
} from 'react-router';

import {
  Flex,
  icons,
  SVG,
  utils,
} from 'web-styled';

import {
  Button,
  InlineInput,
} from 'web-components';

interface WorkoutExerciseProps {
  number: number;
  readOnly?: boolean;
  topLine?: boolean;
  bottomLine?: boolean;
}

export const WorkoutExercise = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
  spacing: 15,
}) <WorkoutExerciseProps>`
  width: 100%;
  padding: 2px 10px;
  border-radius: 10px;
  padding-left: 10px;
  position: relative;
  box-sizing: border-box;

  &:hover {
    background: #fbfbfb;
  }

  &:before,
  &:after {
    content: '';
    display: none;
    position: absolute;
    left: ${props => (props.readOnly ? '23px' : '41px')};
    width: 3px;
    height: 50%;
    ${utils.exerciseColor};
    @media print {
      dislay: none;
    }
  }

  ${(props: WorkoutExerciseProps) => props.topLine && `
    &:before {
      display: block;
      top: calc(0% - 4px);
      @media print {
        display: none;
      }
    }
  `}

  ${(props: WorkoutExerciseProps) => props.bottomLine && `
    &:after {
      display: block;
      bottom: calc(0% - 4px);
      @media print {
        display: none;
      }
    }
  `};

  @media print {
    padding: 0;
    align-items: flex-start;
  }
`;

export const Meta = styled(Flex).attrs({
  flex: '0 0 30%',
  align: 'center',
  spacing: 8,
})`
  margin: 0 15px 0 0;
  padding: 8px 0;
  min-width: 340px;
`;

export const Sort = styled(Flex).attrs({
  align: 'center',
  flex: '0 0 14px',
})`
  width: 20px;
  height: 40px;
  opacity: 0.6;
  cursor: move;
  margin-right: 0 !important;
  color: ${props => props.theme.colors.primary};

  &:hover {
    opacity: 1;
  }

  svg {
    margin-right: 2px;
  }

  @media print {
    display: none;
  }
`;

export const Circle = styled(Flex).attrs({
  align: 'center',
  flex: '0 0 30px',
}) <WorkoutExerciseProps>`
  display: block;
  padding: 0;
  border: 0 none;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: ${props => props.color || '#1cd786'};
  transition: background-color 0.3s ease;
  border-radius: 15px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  position: relative;
  user-select: none;

  &:before,
  &:after {
    content: '';
    display: none;
    position: absolute;
    left: 13px;
    width: 3px;
    height: 16px;
    background: inherit;
  }

  ${props => props.topLine && `
    &:before {
      display: block;
      top: -16px;
    }
  `}

  ${props => props.bottomLine && `
    &:after {
      display: block;
      bottom: -16px;
    }
  `}
`;

export const Name = styled(Link)`
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  display: block;
  cursor: pointer;

  @media print {
    color: #333;
    font-weight: 900;
    font-size: 16px;

  }
`;

export const Note = styled(InlineInput).attrs({
  minRows: 1,
  isTextarea: true,
})`
  font-size: 12px;
  background: transparent;
  outline: none;
  padding: 0;
  border: none !important;
  box-shadow: none !important;
  height: auto;
  cursor: text;
  white-space: pre-line;
  padding-right: 10px;

  @media print {
    color: #000;
    ${props => !props.defaultValue && `
      display: none;
    `}
  }
`;

export const ActionsTrigger = styled(Button).attrs({
  appearance: 'link',
})`
  width: 14px;
  height: 40px;
  padding: 0;
  margin-right: 0 !important;
  background-image: url(${icons.dropdownMenu});
  background-size: 45px;
  background-repeat: no-repeat;
  background-position: -20px -5px;

  @media print {
    display: none;
  }
`;

export const Add = styled(Flex).attrs({
  align: 'center',
})`
  cursor: pointer;
  width: 25px;
  height: 25px;
  border: none;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: props.theme.colors.primary,
  }),
)``;

export const ExerciseSeparator = styled.hr`
  display: none;
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 50px);
  height: 1px;
  background-color: #7c7c7c;
  margin: 0;
  padding: 0;
  border: none;

  @media print {
    display: block;
  }
`;

export const ExerciseDescritprion = styled(Flex)`
  align-items: center;
  flex: 0 0 30%;
`;

export const PropertyGroup = styled(Flex).attrs({
  spacing: 10,
})`
  align-items: center;

  @media print {
    flex: 0 0 50%;
  }
`;
